import { render, staticRenderFns } from "./Button.vue?vue&type=template&id=8c178dca&scoped=true"
import script from "./Button.js?vue&type=script&lang=js&external"
export * from "./Button.js?vue&type=script&lang=js&external"
import style0 from "./Button.scss?vue&type=style&index=0&id=8c178dca&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c178dca",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotIcon: require('/home/runner/_work/app-hotmart-legal/app-hotmart-legal/components/Atoms/Icon/Icon.vue').default})
